module.exports = __webpack_public_path__ + "img/logbook-green.svg";